import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=264c6568&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"
import style0 from "./Devices.vue?vue&type=style&index=0&id=264c6568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c6568",
  null
  
)

export default component.exports